import { useState } from "react";
import { motion } from "framer-motion";

const workPlace = [
  {
    date: "September 2024 - Present ~ (Windsor, ON)",
    title: "Central Transport",
    subTitle: "Data Entry Associate (Part-Time)",
  },
  {
    date: "February 2023 - March 202 ~ (Ajmer, Rajasthan)",
    title: "Tummo Labs Pvt Ltd)",
    subTitle: "Full Stack Developer",
  },
  {
    date: "July 2022 - February 2023 ~ (Thane, Maharashtra)",
    title: "Tata Consultancy Services Limited",
    subTitle: "Assistant Systems Engineer",
  },
  {
    date: "February 2021 - April 2021 ~ (Trivandrum, Kerala)",
    title: "Whoolab Pvt Ltd",
    subTitle: "Flutter Developer Intern",
  },
  {
    date: "June 2020 - August 2020 ~ (Trivandrum, Kerala)",
    title: "Whoolab Pvt Ltd",
    subTitle: "UI Design Intern",
  },
  {
    date: "Mar 2019 - May 2019 ~ (remote)",
    title: "Internshala",
    subTitle: "Digital Marketing Intern",
  },
];

function WorkExperience() {
  const [animationComplete, setAnimationComplete] = useState(
    new Array(workPlace.length).fill(false)
  );

  const handleAnimationComplete = (index) => {
    setAnimationComplete((prev) => {
      const newStatus = [...prev];
      newStatus[index] = true;
      return newStatus;
    });
  };

  return (
    <>
      <ol className="mt-10 overflow-hidden space-y-8 font-poppins">
        {workPlace.map((element, index) => (
          <li
            className={`${
              index !== workPlace.length - 1 && animationComplete[index]
                ? "relative flex-1 after:content-[''] after:w-0.5 after:h-full after:bg-purple-500 after:inline-block after:absolute after:-bottom-8 after:left-2 after:opacity-0 after:animate-fadeIn"
                : ""
            }`}
          >
            <p href="/" className="flex items-start font-medium w-full">
              <motion.div
                key={index}
                exit={{ scale: 1 }}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 1 }}
                onAnimationComplete={() => handleAnimationComplete(index)}
              >
                <span className="w-4 h-4 mt-2 aspect-square bg-purple-500 border-2 border-transparent rounded-full flex justify-center items-center mr-3 text-sm text-white"></span>
              </motion.div>

              <div className="block">
                <motion.div
                  key={index}
                  exit={{ scale: 1 }}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <p className="text-gray-300 text-xl font-bold mb-2">
                    {element.title}
                  </p>
                </motion.div>
                <motion.div
                  key={index}
                  exit={{ scale: 1 }}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.7 }}
                >
                  <p className="text-sm text-purple-300 max-w-xs mb-4">
                    {element.date}
                    <br />
                  </p>
                </motion.div>
                <motion.div
                  key={index}
                  exit={{ scale: 1 }}
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.9 }}
                >
                  <p className="text-sm text-gray-300 max-w-xs mb-4">
                    {element.subTitle}
                    <br />
                  </p>
                </motion.div>
              </div>
            </p>
          </li>
        ))}
      </ol>
    </>
  );
}

export default WorkExperience;
